import { render, staticRenderFns } from "./AulasPraticasEnviadas.vue?vue&type=template&id=3a74ce0c"
import script from "./AulasPraticasEnviadas.vue?vue&type=script&lang=js"
export * from "./AulasPraticasEnviadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports